import { useIntl } from 'react-intl'

import Seat from '../../../../../../components/Seat/Seat'
import Tooltip from '../../../../../../components/Tooltip/Tooltip'
import Typography from '../../../../../../components/Typography/Typography'

import TooltipWindowNew from 'components/Windows/TooltipWindow/TooltipWindowNew'
import './LegendItem.scss'

const LegendItem = ({ seatInfoData, type, size = 'single', withTooltip }) => {
    const intl = useIntl()

    return (
        <div className={'legend-item'}>
            <Seat type={type} size={size} disabled />
            <Typography variant={'p'}>{seatInfoData ? seatInfoData?.seatTitle : ''}</Typography>
            {withTooltip && (
                <>
                    <Tooltip
                        id={`${type}-${size}-mobile`}
                        content={
                            <TooltipWindowNew
                                name={`${type}-${size}`}
                                imgUrl={seatInfoData?.image[0]?.url}
                                title={seatInfoData?.seatTitle}
                                subtitle={seatInfoData?.seatDescription}
                                seatProperties={seatInfoData?.seatProperties}
                            />
                        }
                        placement={'top'}
                        className={'legend-item--tooltip-mobile'}
                        clickable
                    />
                    <Tooltip
                        id={`${type}-${size}`}
                        content={
                            <TooltipWindowNew
                                name={`${type}-${size}`}
                                imgUrl={seatInfoData?.image[0]?.url}
                                title={seatInfoData?.seatTitle}
                                subtitle={seatInfoData?.seatDescription}
                                seatProperties={seatInfoData?.seatProperties}
                            />
                        }
                        placement={'top'}
                        className={'legend-item--tooltip-desktop'}
                    />
                </>
            )}
        </div>
    )
}

export default LegendItem
